<div class="std-ta-center">
    <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">Warning</h3>
    <p nxCopytext="normal" class="nx-font-weight-light nx-margin-bottom-m">
        {{ this.message }}
    </p>
    <button nxModalClose class="nx-margin-bottom-m" nxButton="primary" type="button" (click)="onClickOK()">
        OK
    </button>
</div>